
import Teacher from "../../../assets/filled/Teacher.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TeacherIcon({ className, dataTestid = "TeacherIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Teacher data-testid={dataTestid} className={classes} {...rest} />
  );
}
